const BASE_URL = "https://www.luminartechnolab.com"

const serverurl =`${BASE_URL}/api`
export const serverUrl2 =`${BASE_URL}/common`
export default serverurl

